/** @format */

import React from 'react';
import { Card } from 'antd';
import { Customer } from '../types/customer';

interface BackOfficeInfoCardProps {
  customer: Customer;
}

const BackOfficeInfoCard: React.FC<BackOfficeInfoCardProps> = ({ customer }) => {
  return (
    <Card title="Back Office Information">
      <div style={{ padding: '10px' }}>
        <p>
          <strong>Agent Name:</strong> {(customer.user?.firstName ) + ' ' + (customer.user?.lastName ) || 'N/A'}
        </p>
        <p>
          <strong>AOR:</strong> {customer.AOR || 'N/A'}
        </p>
        <p>
          <strong>Health Sherpa:</strong> {customer.healthSherpa || 'N/A'}
        </p>
        <p>
          <strong>NPN OverRide:</strong> {customer.NPN || 'N/A'}
        </p>
        <p>
          <strong>QLE:</strong> {customer.QLE || 'N/A'}
        </p>
        <p>
          <strong>Enrollment Fee:</strong> ${customer.enrollmentFee || 'N/A'}
        </p>
      </div>
    </Card>
  );
};

export default BackOfficeInfoCard;
